import React, { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import nl from 'date-fns/locale/nl';
import 'react-datepicker/dist/react-datepicker.css';

import CustomDateField from '../Form/Field/CustomDateField';

import { Filter } from '../../../Enum/Filters';

import { convertDateToDutchString, convertString } from '../../../Helpers/Date';
import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import { filterChanged } from '../../../Store/Filter/action';

const DateRangeFilter: React.FC = () => {
    const dispatch = useDispatch();
    const dateFrom = useGetFilterValue(Filter.DateFrom) as string;
    const dateTo = useGetFilterValue(Filter.DateTo) as string;
    const inputFromRef = useRef(null);
    const inputToRef = useRef(null);

    const setDateFrom = useCallback(
        (date: Date): void => {
            dispatch(filterChanged(Filter.DateFrom, convertDateToDutchString(date) || ''));
        },
        [dispatch],
    );

    const setDateTo = useCallback(
        (date: Date): void => {
            dispatch(filterChanged(Filter.DateTo, convertDateToDutchString(date) || ''));
        },
        [dispatch],
    );

    return (
        <Form className="popover-select-form" autoComplete="off">
            <Form.Group>
                <Form.Label>Zoek op datum</Form.Label>
                <Form.Row>
                    <Col xs={12}>
                        <DatePicker
                            selected={convertString(dateFrom)}
                            onChange={(date: Date) => setDateFrom(date)}
                            startDate={convertString(dateFrom)}
                            endDate={convertString(dateTo)}
                            maxDate={convertString(dateTo)}
                            selectsStart
                            isClearable
                            locale={nl}
                            placeholderText={'Vanaf'}
                            className={'form-control'}
                            customInput={<CustomDateField ref={inputFromRef} />}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            dateFormat="dd/MM/yyyy"
                        />
                    </Col>
                    <Col xs={12}>
                        <DatePicker
                            selected={convertString(dateTo)}
                            onChange={(date: Date) => setDateTo(date)}
                            startDate={convertString(dateFrom)}
                            endDate={convertString(dateTo)}
                            minDate={convertString(dateFrom)}
                            selectsEnd
                            isClearable
                            locale={nl}
                            placeholderText={'T/m'}
                            className={'form-control'}
                            customInput={<CustomDateField ref={inputToRef} />}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            dateFormat="dd/MM/yyyy"
                        />
                    </Col>
                </Form.Row>
            </Form.Group>
        </Form>
    );
};

export default DateRangeFilter;
